import {Component, Input, ViewEncapsulation, OnInit, Output, EventEmitter} from '@angular/core';
import { BaseComponent } from '../BaseComponent';
import { TranslateService } from '@ngx-translate/core';
import { SessionService } from 'src/app/session-service.service';
import { ComponentCommunicationService } from 'src/app/component-communication.service';

@Component({
  selector: 'app-text-input',
  templateUrl: 'text-input.html',
  styleUrls: ['text-input.css'],
  encapsulation: ViewEncapsulation.None,
})
export class TextInputComponent extends BaseComponent implements OnInit {
  @Input()
  maxCharacters: number;

  @Input()
  dropSpecialCharacters: boolean;

  @Input()
  showMaskTyped: boolean;

  @Input()
  placeHolderCharacter: string;

  @Input()
  prefix = '';

  @Input()
  suffix = '';

  @Input()
  inputMask: string;

  @Input()
  pattern: string = null;

  @Input()
  uppercase = false;

  @Input()
  capitalize = false;

  @Input()
  type = 'text';

  @Input()
  inputBorderColor: string;

  @Input()
  inputColor: string;

  @Input()
  fontColor: string;

  @Input()
  fontSize: string;

  @Input()
  secondInsured: boolean;

  @Input()
  additionalInfoInsurer: string = null;

  @Input()
  isLoaderShown = false;

  @Input()
  isCalculatorShown: boolean;

  @Input()
  thousandSeparator = '';

  @Input()
  isDisabled?: boolean;

  @Output()
  toggleCalculator = new EventEmitter();

  controlType = this.constructor.name;

  constructor(translateService: TranslateService,
              sessionService: SessionService,
              private componentCommunicationService: ComponentCommunicationService) {
    super(translateService, sessionService);
  }

  openPopup(): void{
    this.componentCommunicationService.loadDialog(this.additionalInfoInsurer);
  }

  showCalculator(): void {
    this.toggleCalculator.emit();
  }
}
